import { z } from "zod";
import type { ToolDescription } from "../tool.js";

export const debugToolDescriptions = {
  throwErrorInConvexTool: {
    name: "throwErrorInConvexTool",
    debugOnly: true,
    readonly: true,
    description: `Throw an error in a convex MCP tool.`,
    inputSchema: z.object({}),
  },
  showContext: {
    name: "showContext",
    debugOnly: true,
    readonly: true,
    description: `Show context`,
    inputSchema: z.object({}),
  },
} satisfies Record<string, ToolDescription>;
